import React, { ReactNode } from 'react';
import { transformHTMLParserLinks } from '../../../../utils/rewriteLink/rewriteLink';
import { addressValidationSemaphore } from '../../util/addressValidationSemaphore';
import useFormDirections from '../DataEntryForm/FormDirections/useFormDirections';
import { usePageProperties } from '../../providers/PagePropertiesProvider';
import useSessionStorageCheck from '../../../../hooks/useSessionStorageCheck';
import { useSessionStorageStatus } from '../../../../providers/SessionStorageStatus/SessionStorageStatusProvider';
import { Row, Col } from '../../../../importCL';
import orangeAsterisk from '../../../../component-library/assets/icons/orange-asterisk.svg';
import { useWidth } from '../../../../component-library/hooks/useWidth';

export default function Form_OrangeAsterisk({ children }: { children: ReactNode }) {
    const { formTitle, formSubtitle } = usePageProperties();
    const { onSubmitHandler } = useFormDirections();
    const { status } = useSessionStorageStatus();
    const width = useWidth();
    useSessionStorageCheck();
    
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (status === 'usable') {
            await addressValidationSemaphore.acquire();
            onSubmitHandler();
            addressValidationSemaphore.release();
        }
    };

    return (
        <form className='mb-6'
            onSubmit={handleSubmit}
            onKeyDown={(e) => {
                if (e.key === "Enter" && !(e.target instanceof HTMLButtonElement)) {
                    e.preventDefault();
                }
            }}
            noValidate
        >
            <Row>
                <Col>
                    { formTitle && 
                        <p className='font-bold'>{transformHTMLParserLinks(formTitle)}</p>
                    }
                    { formSubtitle && 
                        <>
                            {width > 768 && <p>{transformHTMLParserLinks(formSubtitle.replace(/\*/g, '<span class="PqdeForm-Form__asterisk">*</span>'))}</p>}
                            {width <= 768 && <p>{transformHTMLParserLinks(formSubtitle.replace(/\*/g, `<img className=${'PqdeForm-Form__asterisk--orange'} src=${orangeAsterisk}/>`))}</p>}
                        </>
                    }
                </Col>
            </Row>
            {children}
        </form>
    );


}